<template>
  <div>
    <h1 class="page-header">
      <i class="fa-solid fa-comments-dollar"></i> Tranzakciók <small></small>
    </h1>
    <hr />
    <panel title="tranzakciók">
      <form @submit.prevent="getTransactionsByDate">
        <div class="row mb-2">
          <div class="col-lg-3">
            <input
              type="date"
              class="form-control"
              v-model="form.from"
              required
              placeholder="kezdő dátum"
            />
          </div>
          <div class="col-lg-3">
            <input
              type="date"
              class="form-control"
              v-model="form.to"
              required
              placeholder="vég dátum"
            />
          </div>
          <div class="col">
            <button class="btn btn-success" type="submit">
              <i class="fa fa-search"></i> Lekérdezés időszakra
            </button>
          </div>
        </div>
      </form>
      <Loading v-if="!transactions"></Loading>
      <NoRecords
        v-else-if="transactions.length == 0"
        main_icon="fa-solid fa-calendar-xmark"
        title="nincsenek tranzakciók"
      ></NoRecords>
      <div class="table-responsive" v-else>
        <vue-good-table
          :columns="columns"
          :rows="transactions"
          :lineNumbers="true"
          :search-options="{ enabled: false, placeholder: 'Keresés...' }"
          :pagination-options="{
            enabled: true,
            position: 'bottom',
            perPage: 20,
          }"
          :row-style-class="rowStyleClassFn"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'created_at'">
              {{ props.row.created_at | moment("YYYY-MM-DD HH:mm") }}
            </span>
            <span v-else-if="props.column.field == 'model_id'">
              <router-link
                v-if="!props.row.is_booking_deleted"
                class="btn btn-black btn-xs"
                style="text-decoration: none"
                :to="'/bookings/' + props.row.model_id"
              >
                #{{ props.row.model_id }}
              </router-link>
              <span v-else class="badge bg-danger">törölt foglalás</span>
            </span>
            <span v-else-if="props.column.field == 'price'">
              <span v-if="props.row.price != '-'">
                {{ props.row.direction == 2 ? "-" : "" }}
                {{ props.row.price.toLocaleString("hu-HU") }} Ft
              </span>
              <span v-else>{{ props.row.price }}</span>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </panel>
  </div>
</template>

<script>
import Transaction from "../../apis/Transaction";
export default {
  data() {
    return {
      transactions: false,
      form: {
        from: null,
        to: null,
      },
      columns: [
        {
          label: "Foglalás azonosító",
          field: "model_id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Vendég neve",
          field: "guest_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Kártya típusa",
          field: "card_type",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Tranzakció időpont",
          field: "created_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Státusz",
          field: "status_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Összeg",
          field: "price",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
          tdClass: "text-end",
        },
      ],
    };
  },
  created() {
    Transaction.index().then((response) => {
      this.transactions = response.data;
    });
  },
  methods: {
    getTransactionsByDate() {
      Transaction.indexDate(this.form).then((response) => {
        this.transactions = response.data;
      });
    },
    rowStyleClassFn(row) {
      return row.direction == 1
        ? "bg-green"
        : row.direction == 2
        ? "bg-red"
        : "";
    },
  },
};
</script>
